import { render, staticRenderFns } from "./ReturnOrderDetailsItemView.vue?vue&type=template&id=746e2a21&"
import script from "./ReturnOrderDetailsItemView.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderDetailsItemView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderDetailsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('746e2a21')) {
      api.createRecord('746e2a21', component.options)
    } else {
      api.reload('746e2a21', component.options)
    }
    module.hot.accept("./ReturnOrderDetailsItemView.vue?vue&type=template&id=746e2a21&", function () {
      api.rerender('746e2a21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnOrderDetailsItemView.vue"
export default component.exports